// Intentionally empty. Aliased over Next.js's built-in polyfill-module in
// next.config.ts (turbopack.resolveAlias) — that module unconditionally ships
// String/Array/Object polyfills (trimStart, flat, flatMap, fromEntries, at,
// hasOwn, URL.canParse) regardless of our browserslist target, because it's
// feature-detected ("x" in Y || (...)) rather than build-time excluded. Every
// target browser in .browserslistrc already has all of these natively, so
// the whole module is dead weight — this file replaces it with nothing.
